<template>
  <div style="padding: 0 8px 16px;">
    <div style="display: flex; justify-content: space-between;align-items: center;margin-bottom: 16px">
      <span style="font-weight: bold;">历史记录</span>
      <el-button type="primary" @click="handleEdit(-1)">添加</el-button>
    </div>
<!--    <div v-if="pageDataList.length > 0">-->
<!--      <div v-for="(item,index) in pageDataList" :key="index" style="margin: 20px 0;">-->
<!--        <span>{{item.createTime}}</span>-->
<!--        <el-tag style="margin: 0 10px;">{{item.name}}</el-tag>-->
<!--        <span>{{item.content}}</span>-->
<!--      </div>-->
<!--    </div>-->
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        v-loading="listLoading"
        border
    >
      <el-table-column property="createTime" label="时间" width="180"/>
      <el-table-column property="name" label="用户" width="100"></el-table-column>
      <el-table-column property="content" label="内容"/>
      <el-table-column property="name" label="操作" width="100" v-if="(operateState & 2) == 2">
        <template #default="scope">
          <el-link type="primary" style="margin-right: 12px" @click="handleEdit(scope.$index,scope.row)">编辑</el-link>
          <el-link type="danger" @click="delLog(scope.$index,scope.row)" v-loading="scope.row.delLoading">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
<!--    <el-empty v-else description="没有记录"></el-empty>-->
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData, postFormData} from '../../api/api';
import { getUserLogPageList, delUserLog } from '../../api/url';
import Dialog from '../../assets/js/dialog'
import AddUserLogDialog from './AddUserLogDialog'
export default {
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      userId: this.value.id,
      totalRow: 0,
      pagesize: 20,
      currentPage: 1,
      operateState: JSON.parse(sessionStorage.getItem('operateState'))
    }
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      let param = {
        'userId': this.userId,
        'pageNum': this.currentPage
      }
      getFormData(getUserLogPageList, param).then((data) => {
        if(data.code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pagesize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }
      })
    },

    handleEdit(idx, row) {
      let logForm = {}
      let title = '添加日志'
      if(idx > -1) {
        logForm = Object.assign({},row)
        title = '编辑日志'
      }
      Dialog.open({
        title: '',
        component: AddUserLogDialog,
        data: {
          userId: this.userId,
          logForm: logForm,
          idx: idx,
          width: '500px'
        },
        confirm: (result) => {
          this.getPage();
        }
      })
    },

    delLog(idx, row) {
      row.delLoading = true
      this.$confirm('确认删除此纪录').then(()=>{
        postFormData(delUserLog, {id: row.id}).then(data => {
          let {code,msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            this.pageDataList.splice(idx, 1)
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.delLoading = false;
        })
      })
    },

  },
  mounted() {
    sessionStorage.removeItem('userLog');
    this.getPage();
  }
}
</script>

<style>

</style>
